import { z } from "zod/v4";

export const FilteredPluginPerformanceResultsReportSchema = z.object({
  TTFB: z.number().nullish(),
  startRender: z.number().nullish(),
  FCP: z.number().nullish(),
  speedIndex: z.number().nullish(),
  LCP: z.number().nullish(),
  TBT: z.number().nullish(),
  cpuTime: z.number().nullish(),
  // lighthouseFirstContentfulPaintMs: z.number().nullish(),
  // lighthouseSpeedIndexMs: z.number().nullish(),
  // lighthouseLargestContentfulPaintMs: z.number().nullish(),
  // lighthouseTimeToInteractiveMs: z.number().nullish(),
  // lighthouseTotalBlockingTimeMs: z.number().nullish(),
  // lighthousePerformanceScorePercent: z.number().nullish(),
});
export type FilteredPluginPerformanceResultsReportType = z.infer<
  typeof FilteredPluginPerformanceResultsReportSchema
>;

export const PluginPerformancesResultsReportSchema = z.object({
  id: z.string().nullish(),
  url: z.string().nullish(),
  summary: z.string().nullish(),
  html_result_url: z.string().nullish(),
  testUrl: z.string().nullish(),
  completed: z.number().nullish(),
  median: z.object({
    firstView: z.object({
      TTFB: z.number(),
      render: z.number(),
      firstContentfulPaint: z.number(),
      SpeedIndex: z.number(),
      "chromeUserTiming.LargestContentfulPaint": z.number(),
      TotalBlockingTime: z.number(),
      requests: z.object({ host: z.string(), cpuTime: z.number() }).array(),
    }),
  }),
  lighthouse: z.object({
    finalDisplayedUrl: z.string(),
    finalFetchTime: z.number(),

    audits: z.object({
      "first-contentful-paint": z.object({
        numericValue: z.number(),
      }),
      "largest-contentful-paint": z.object({
        numericValue: z.number(),
      }),
      "speed-index": z.object({
        numericValue: z.number(),
      }),
      "total-blocking-time": z.object({
        numericValue: z.number(),
      }),
      interactive: z.object({
        numericValue: z.number(),
      }),
    }),
    categories: z.object({
      performance: z.object({ score: z.number() }),
    }),
  }),
  runs: z.record(
    z.any(),
    z.object({
      firstView: z.object({
        firstPaint: z.number().nullish(),
        firstContentfulPaint: z.number().nullish(),
        firstMeaningfulPaint: z.number().nullish(),
      }),
    })
  ),
});

export type PluginPerformancesResultsReportType = z.infer<
  typeof PluginPerformancesResultsReportSchema
>;

export const PluginPerformanceTableSchema = z.object({
  id: z.string(),
  orgId: z.uuid(),
  blockIntelligems: z.boolean(),
  themeId: z.string().nullish(),
  results: PluginPerformancesResultsReportSchema.nullish(),
});

export type PluginPerformanceTableType = z.infer<
  typeof PluginPerformanceTableSchema
>;

export const PendingPluginPerformanceTestSchema = z.object({
  testId: z.string(),
  label: z.string(),
  url: z.string(),
});

export type PendingPluginPerformanceTestType = z.infer<
  typeof PendingPluginPerformanceTestSchema
>;

export const PluginPerformanceSchema = z.object({
  id: z.string(),
  orgId: z.uuid(),
  blockIntelligems: z.boolean(),
  summary: z.string().nullish(),
  testUrl: z.string().nullish(),
  themeId: z.string().nullish(),
  completed: z.number().nullish(),
  s3: z.boolean(),
  results: FilteredPluginPerformanceResultsReportSchema.nullish(),
});

export type PluginPerformanceType = z.infer<typeof PluginPerformanceSchema>;
